/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M16 21.5V19.2C16 18.0799 16 17.5198 16.218 17.092C16.4097 16.7157 16.7157 16.4097 17.092 16.218C17.5198 16 18.0799 16 19.2 16H21.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 11.6C2 8.23969 2 6.55953 2.65396 5.27606C3.2292 4.14708 4.14708 3.2292 5.27606 2.65396C6.55953 2 8.23969 2 11.6 2H12.4C15.7603 2 17.4405 2 18.7239 2.65396C19.8529 3.2292 20.7708 4.14708 21.346 5.27606C22 6.55953 22 8.23969 22 11.6V15.1716C22 15.5088 22 15.6774 21.9912 15.8399C21.9171 17.2049 21.3791 18.5036 20.4663 19.5212C20.3577 19.6423 20.2385 19.7615 20 20V20C19.7615 20.2385 19.6423 20.3577 19.5212 20.4663C18.5036 21.3791 17.2049 21.9171 15.8399 21.9912C15.6774 22 15.5088 22 15.1716 22H11.6C8.23969 22 6.55953 22 5.27606 21.346C4.14708 20.7708 3.2292 19.8529 2.65396 18.7239C2 17.4405 2 15.7603 2 12.4V11.6Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M12.4 2H11.6C8.23969 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22H13C13.9319 22 14.3978 22 14.7654 21.8478C15.2554 21.6448 15.6448 21.2554 15.8478 20.7654C16 20.3978 16 19.9319 16 19C16 18.0681 16 17.6021 16.1522 17.2346C16.3552 16.7445 16.7446 16.3552 17.2346 16.1522C17.6022 16 18.0681 16 19 16C19.9319 16 20.3978 16 20.7654 15.8477C21.2554 15.6447 21.6448 15.2554 21.8478 14.7653C22 14.3978 22 13.9319 22 13V11.6C22 8.23969 22 6.55953 21.346 5.27606C20.7708 4.14708 19.8529 3.2292 18.7239 2.65396C17.4405 2 15.7603 2 12.4 2Z"
				fill="currentColor"
			/>
			<path
				d="M16 21.5V19.2C16 18.0799 16 17.5198 16.218 17.092C16.4097 16.7157 16.7157 16.4097 17.092 16.218C17.5198 16 18.0799 16 19.2 16H21.5M15.1716 22H11.6C8.23969 22 6.55953 22 5.27606 21.346C4.14708 20.7708 3.2292 19.8529 2.65396 18.7239C2 17.4405 2 15.7603 2 12.4V11.6C2 8.23969 2 6.55953 2.65396 5.27606C3.2292 4.14708 4.14708 3.2292 5.27606 2.65396C6.55953 2 8.23969 2 11.6 2H12.4C15.7603 2 17.4405 2 18.7239 2.65396C19.8529 3.2292 20.7708 4.14708 21.346 5.27606C22 6.55953 22 8.23969 22 11.6V15.1716C22 15.5088 22 15.6774 21.9912 15.8399C21.9171 17.2049 21.3791 18.5036 20.4663 19.5212C20.3577 19.6423 20.2385 19.7615 20 20V20C19.7615 20.2385 19.6423 20.3577 19.5212 20.4663C18.5036 21.3791 17.2049 21.9171 15.8399 21.9912C15.6774 22 15.5088 22 15.1716 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.52606 1.90396C5.80953 1.25 7.48969 1.25 10.85 1.25H13.15C16.5103 1.25 18.1905 1.25 19.4739 1.90396C20.6029 2.4792 21.5208 3.39708 22.096 4.52606C22.75 5.80953 22.75 7.48969 22.75 10.85V15.1716C22.75 15.1983 22.75 15.2244 22.75 15.25H19.2H19.1695H19.1695C18.6354 15.25 18.1896 15.25 17.8253 15.2797C17.4454 15.3108 17.0888 15.3779 16.7515 15.5497C16.2341 15.8134 15.8134 16.2341 15.5497 16.7515C15.3779 17.0888 15.3108 17.4454 15.2797 17.8253C15.25 18.1896 15.25 18.6354 15.25 19.1696V19.2V22.75C15.2244 22.75 15.1983 22.75 15.1716 22.75H10.85C7.48968 22.75 5.80953 22.75 4.52606 22.096C3.39708 21.5208 2.4792 20.6029 1.90396 19.4739C1.25 18.1905 1.25 16.5103 1.25 13.15V10.85C1.25 7.48968 1.25 5.80953 1.90396 4.52606C2.4792 3.39708 3.39708 2.4792 4.52606 1.90396ZM16.75 22.6783C17.7964 22.5151 18.7829 22.0775 19.6079 21.4075C19.8487 21.212 20.0759 20.9848 20.5303 20.5304L20.5303 20.5303L20.5304 20.5303C20.9848 20.0759 21.212 19.8487 21.4075 19.6079C22.0775 18.7829 22.5151 17.7964 22.6783 16.75H19.2C18.6276 16.75 18.2434 16.7506 17.9475 16.7748C17.6604 16.7982 17.5231 16.8401 17.4325 16.8862C17.1973 17.0061 17.0061 17.1973 16.8862 17.4325C16.8401 17.5231 16.7982 17.6604 16.7748 17.9475C16.7506 18.2434 16.75 18.6276 16.75 19.2V22.6783Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2 10V9.5V9.5C2 8.10603 2 7.40905 2.11529 6.82946C2.58873 4.44931 4.44931 2.58873 6.82946 2.11529C7.40905 2 8.10603 2 9.5 2H12.4C15.7603 2 17.4405 2 18.7239 2.65396C19.8529 3.2292 20.7708 4.14708 21.346 5.27606C22 6.55953 22 8.23969 22 11.6V15.1716C22 15.5088 22 15.6774 21.9912 15.8399C21.9171 17.2049 21.3791 18.5036 20.4663 19.5212C20.3577 19.6423 20.2385 19.7615 20 20V20C19.7615 20.2385 19.6423 20.3577 19.5212 20.4663C18.5036 21.3791 17.2049 21.9171 15.8399 21.9912C15.6774 22 15.5088 22 15.1716 22H9.5C8.10603 22 7.40905 22 6.82946 21.8847C4.44931 21.4113 2.58873 19.5507 2.11529 17.1705C2 16.5909 2 15.894 2 14.5V14.5V14M16 21.5V19C16 18.0681 16 17.6021 16.1522 17.2346C16.3552 16.7445 16.7446 16.3552 17.2346 16.1522C17.6022 16 18.0681 16 19 16V16H19.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M16 21.5V19.2C16 18.0799 16 17.5198 16.218 17.092C16.4097 16.7157 16.7157 16.4097 17.092 16.218C17.5198 16 18.0799 16 19.2 16H21.5M15.1716 22H11.6C8.23969 22 6.55953 22 5.27606 21.346C4.14708 20.7708 3.2292 19.8529 2.65396 18.7239C2 17.4405 2 15.7603 2 12.4V11.6C2 8.23969 2 6.55953 2.65396 5.27606C3.2292 4.14708 4.14708 3.2292 5.27606 2.65396C6.55953 2 8.23969 2 11.6 2H12.4C15.7603 2 17.4405 2 18.7239 2.65396C19.8529 3.2292 20.7708 4.14708 21.346 5.27606C22 6.55953 22 8.23969 22 11.6V15.1716C22 15.5088 22 15.6774 21.9912 15.8399C21.9171 17.2049 21.3791 18.5036 20.4663 19.5212C20.3577 19.6423 20.2385 19.7615 20 20V20C19.7615 20.2385 19.6423 20.3577 19.5212 20.4663C18.5036 21.3791 17.2049 21.9171 15.8399 21.9912C15.6774 22 15.5088 22 15.1716 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M10.85 22.75C7.48969 22.75 5.80953 22.75 4.52606 22.096C3.39708 21.5208 2.4792 20.6029 1.90396 19.4739C1.25 18.1905 1.25 16.5103 1.25 13.15V10.85C1.25 7.48969 1.25 5.80953 1.90396 4.52606C2.4792 3.39708 3.39708 2.4792 4.52606 1.90396C5.80953 1.25 7.48969 1.25 10.85 1.25H13.15C16.5103 1.25 18.1905 1.25 19.4739 1.90396C20.6029 2.4792 21.5208 3.39708 22.096 4.52606C22.75 5.80953 22.75 7.48969 22.75 10.85V15.25H20.05C18.3698 15.25 17.5298 15.25 16.888 15.577C16.3235 15.8646 15.8646 16.3235 15.577 16.888C15.25 17.5298 15.25 18.3698 15.25 20.05V22.75H10.85Z"
				fill="currentColor"
			/>
			<path
				d="M16.75 22.75C17.7493 22.75 18.7076 22.353 19.4142 21.6464L21.6464 19.4142C22.353 18.7076 22.75 17.7493 22.75 16.75H19.95C18.8299 16.75 18.2698 16.75 17.842 16.968C17.4657 17.1597 17.1597 17.4657 16.968 17.842C16.75 18.2698 16.75 18.8299 16.75 19.95V22.75Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
